import { useState, useCallback } from 'react';

export type PersonCount = '20-50' | '50-100' | '100-250' | '250+' | 'unknown';
export type ServiceType = 'Fabrika' | 'İnşaat / Şantiye' | 'Şirket / Ofis' | 'Okul / Kurum' | 'Film / Dizi Seti' | 'Organizasyon' | 'Diğer';
export type Timing = 'En kısa sürede' | 'Bu hafta' | 'Bu ay' | 'İleri tarih';

export interface WhatsAppData {
  personCount: PersonCount | null;
  serviceType: ServiceType | null;
  region: string;
  timing: Timing | null;
}

const PHONE = '905427762227';

export function useWhatsApp() {
  const [data, setData] = useState<WhatsAppData>({
    personCount: null,
    serviceType: null,
    region: '',
    timing: null,
  });

  const [isOpen, setIsOpen] = useState(false);

  const openModal = useCallback((preSelectedService?: ServiceType, preSelectedPersonCount?: PersonCount) => {
    setData({
      personCount: preSelectedPersonCount || null,
      serviceType: preSelectedService || null,
      region: '',
      timing: null,
    });
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  const updateData = useCallback((updates: Partial<WhatsAppData>) => {
    setData((prev) => ({ ...prev, ...updates }));
  }, []);

  const generateMessage = useCallback(() => {
    const { personCount, serviceType, region, timing } = data;
    const lines = [
      'Merhaba Kaya Catering, toplu yemek hizmeti için teklif almak istiyorum.',
    ];

    if (serviceType) {
      lines.push(`Hizmet: ${serviceType}`);
    }
    if (personCount) {
      const personLabel = personCount === 'unknown' ? 'Henüz belli değil' : `${personCount} kişi`;
      lines.push(`Kişi Sayısı: ${personLabel}`);
    }
    if (region.trim()) {
      lines.push(`Bölge: ${region.trim()}`);
    }
    if (timing) {
      lines.push(`Başlangıç: ${timing}`);
    }

    lines.push('Bana uygun catering teklifiniz hakkında bilgi alabilir miyim?');
    return lines.join('\n');
  }, [data]);

  const generateLink = useCallback(() => {
    const message = encodeURIComponent(generateMessage());
    return `https://wa.me/${PHONE}?text=${message}`;
  }, [generateMessage]);

  return {
    data,
    isOpen,
    openModal,
    closeModal,
    updateData,
    generateLink,
    generateMessage,
  };
}